import React from "react";
import { Radio, Select } from "antd";
import Space from "../../../../../../components/Space";
import styles from "./index.module.scss";
import moment from "moment";

interface PickDurationProps {
    value?: number; // 秒数
    onChange?(value?: number): void;
}

export default function PickDuration({
    value = 0,
    onChange
}: PickDurationProps) {
    const limited = !!value;

    // 天
    const days = Math.floor(moment.duration(value, "s").asDays());

    // 小时
    const hours = Math.floor(moment.duration(value, "s").hours());

    // 分钟
    const minutes = Math.floor(moment.duration(value, "s").minutes());

    function onDayChange(days: number) {
        const newValue = days * 24 * 3600 + hours * 3600 + minutes * 60;
        onChange?.(newValue);
    }

    function onHourChange(hours: number) {
        const newValue = days * 24 * 3600 + hours * 3600 + minutes * 60;
        onChange?.(newValue);
    }

    function onMinuteChange(minutes: number) {
        const newValue = days * 24 * 3600 + hours * 3600 + minutes * 60;
        onChange?.(newValue);
    }

    return (
        <div className={styles.root}>
            <Radio
                className={styles.limit}
                checked={limited}
                onClick={() => onChange?.(24 * 3600)}>
                <Space className={styles.limitLabel}>
                    限时&nbsp;&nbsp;&nbsp;
                    {limited && (
                        <Space>
                            <Select value={days} onChange={onDayChange}>
                                {new Array(365).fill(1).map((_, index) => (
                                    <Select.Option key={index} value={index}>
                                        {index}
                                    </Select.Option>
                                ))}
                            </Select>
                            天
                            <Select value={hours} onChange={onHourChange}>
                                {new Array(24).fill(1).map((_, index) => (
                                    <Select.Option key={index} value={index}>
                                        {index}
                                    </Select.Option>
                                ))}
                            </Select>
                            小时
                            <Select value={minutes} onChange={onMinuteChange}>
                                {new Array(60).fill(1).map((_, index) => (
                                    <Select.Option key={index} value={index}>
                                        {index}
                                    </Select.Option>
                                ))}
                            </Select>
                            分钟
                        </Space>
                    )}
                </Space>
            </Radio>

            <Radio checked={!limited} onClick={() => onChange?.(0)}>
                不限时
            </Radio>
        </div>
    );
}
